import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  border: {
    borderStyle: 'solid',
    borderWidth: 5,
    borderColor: '#00b0f0',
    height: '100%',
    padding: 10,
  },
  page: {
    padding: 20,
  },
  invoice_body: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    margin: 10,
  },
  invoice_table: {
    margin: 10,
  },
  half_section: {
    width: '50%',
    paddingRight: 10,
  },
  half_section_right: {
    width: '50%',
    paddingRight: 10,
  },
  line_item: {
    fontFamily: 'Helvetica',
    fontSize: 12,
    marginBottom: 2,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  line_item_bold: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 12,
    marginBottom: 2,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  subTitle: {
    color: '#0070c0',
    fontSize: 12,
    fontFamily: 'Helvetica-Bold',
    marginBottom: 4,
  },
  subTitle_plain: {
    fontSize: 12,
    fontFamily: 'Helvetica-Bold',
    marginBottom: 4,
  },
  text: {
    fontSize: 12,
    fontFamily: 'Helvetica',
    marginVertical: 1,
  },
  color_text: {
    color: '#0070c0',
    fontSize: 12,
    fontFamily: 'Helvetica',
  },
  title: {
    color: '#0070c0',
    fontFamily: 'Helvetica-Bold',
    fontSize: 24,
    fontWeight: 'heavy',
    textAlign: 'center',
    margin: 10,
  },
  table_header: {
    width: '100%',
    borderTop: 2,
    borderBottom: 2,
    borderColor: '#00b0f0',
    padding: 4,
    fontSize: 12,
    fontFamily: 'Helvetica-Bold',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  table_row: {
    width: '100%',
    borderBottom: 1,
    borderColor: '#00b0f0',
    fontSize: 12,
    fontFamily: 'Helvetica',
    padding: 4,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  comment_box: {
    borderStyle: 'solid',
    borderWidth: 2,
    borderColor: '#00b0f0',
    padding: 5,
    height: 55,
    marginTop: 5,
  },
  signature_box: {
    borderStyle: 'solid',
    borderWidth: 2,
    borderColor: '#00b0f0',
    padding: 5,
    height: 55,
    marginTop: 5,
    textAlign: 'center',
  },
  termsAndConditions_box: {
    borderStyle: 'solid',
    marginTop: 5,
    fontSize: 12,
    fontFamily: 'Helvetica',
  },
  midle_style: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: 2,
  },
  border_midle_style: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: 2,
    borderColor: 'Black',
    borderBottom: 1,
    paddingBottom: 2,
  },
  tax_style: {
    fontFamily: 'Helvetica',
    fontSize: 12,
    marginBottom: 2,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

export default styles;
